const getters = {
    sidebar: state => state.app.sidebar,
    device: state => state.app.device,
    roles: state => state.user.roles
}
export default getters